<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName }}</p>
    </div>
    <div class="outer-wrapper p-datatable mtn-header">
        <!--<div class="p-datatable-header"><span class="header-title">PLAN</span></div> -->
        <div *ngIf="showForm.paytOpt" class="form-content">
            <form [formGroup]="forms.lineSubLineLovForm" class="form">
                <div class="form-container-grid top-form">
                    <div class="field required">
                        <label>Line</label>
                    </div>
                    <div class="">
                        <input formControlName="lineCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('LINE')" [disabled]='btns.lov.lineDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Subline</label>
                    </div>
                    <div class="">
                        <input formControlName="subLineCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('SUBLINE')" [disabled]='btns.lov.sublineDisabled'><mat-icon>search</mat-icon></button>
                    </div>

                    <div class="field required">
                        <label>Plan</label>
                    </div>
                    <div class="">
                        <input formControlName="planCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('PLAN')" [disabled]='btns.lov.planDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>User Type</label>
                    </div>
                    <div class="">
                        <input formControlName="userTypeCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('USERTYPE')" [disabled]='btns.lov.userTypeDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                </div>
            </form>
        </div>
        <osp-table [tblConfig]="tblConfig.paytOpt" (onRowClick)="onRowClick.paytOpt($event)"></osp-table>
        <div id="paytOpt-maintenance-loading"><div class="form-loader"></div></div>
        <div *ngIf="showForm.paytOpt" class="form-content">
            <form [formGroup]="forms.paytOptForm" class="form">
                <div id="paytOpt-error-message"></div>
                <div class="form-container-grid">
                    <div class="field required">
                        <label>Payment Options</label>
                    </div>
                    <div class="span">
                        <input formControlName="paytOptDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('PAYTOPT')" [disabled]='btns.lov.paytOptDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    
                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input formControlName="lastUpdateUser" >
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input formControlName="lastUpdate" >
                    </div>
                </div>
            </form>
            <div class="btn-grp">
                <button class="btn btn2" type="button" (click)="onAdd.paytOpt()" [disabled]="btns.paytOpt.addDisabled" >ADD</button>
                <!-- <button *ngIf="!btns.paytOpt.updateDisabled" class="btn btn2" type="button" (click)="onUpdate.paytOpt()" >UPDATE</button> -->
                <button class="btn btn2" type="button" (click)="onDelete.paytOpt()" [disabled]='btns.paytOpt.deleteDisabled'>DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-grp">
                <button class="btn btn2" type="button" (click)="onSave.paytOpt()" [disabled]='btns.paytOpt.saveDisabled'>SAVE</button>
            </div>
        </div>
    </div>
</div>
